import { apiClient } from "@/lib/api/client";
import type { MetricCreateDto, MetricDto } from "@/lib/api/types";

export async function listMetrics(tenantId: string): Promise<MetricDto[]> {
  const { data } = await apiClient.get<MetricDto[]>("/metrics", {
    params: { tenant_id: tenantId },
  });
  return data;
}

export async function createMetric(body: MetricCreateDto): Promise<MetricDto> {
  const { data } = await apiClient.post<MetricDto>("/metrics", body);
  return data;
}
